import { FieldAndValue } from "./field-and-value";

export class EvolutionNoteFieldAndValue extends FieldAndValue{
  constructor(x?: any) {
    super(x);
  }
}